import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges the classNames using clsx and tailwind-merge.
 * @function mergeClasses
 * @param {...(string|Object)} classNames - Any number of classNames as strings or conditional Objects.
 * @returns {string} Merged and Deduplicated className.
 * @example
 * mergeClasses('bg-blue-500', 'font-bold text-center');
 * // Returns 'bg-blue-500 font-bold text-center'
 * @example
 * mergeClasses('bg-green bg-transparent', { 'font-bold': true, 'text-center': true });
 * // Returns 'bg-transparent font-bold text-center'
 */
export default function mergeClasses(...classNames) {
  return twMerge(clsx(...classNames));
}
